var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MailForwardDataTable',{attrs:{"loading":_vm.loading,"forwardTasks":_vm.forwardTasks,"allow-create-print-package":false,"allow-operations":false},on:{"update":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }